import React from 'react';
import { useStaticQuery, graphql, Link } from "gatsby"
import { Helmet } from "react-helmet";

import Layout from "../components/Layout"
import GuideDetail from "../components/GuideDetail/GuideDetail"
import { breadcrumbs } from "../common/utils/breadcrumbs";
import { PageLinks } from "../common/page-links";
import { site_name } from "../common/constant";
import Journey from "../components/Journey/Journey";
import MoreGuides from "../components/News/MoreGuides"

import _ from "lodash";

const GuidesDetailTemplate = ({data}) => {

  //const[blog, setBlog] = useState("");

  //const { loading, error, data } = NewsDetails(props.pageContext.slug);

  const { glstrapi: { guidesAndResource:guideDetail } } = data;

  // useEffect(()=>{
  //   data?.blogs?.length > 0 && setBlog(data?.blogs[0]);
  // },[data])
  //console.log('blog', blog)
  const bread = [
    { label: 'Guides & Resources', slug: PageLinks.guides_resources }, 
    { label: guideDetail?.title, slug: guideDetail?.slug}
  ]
  const breadcrumbsList = breadcrumbs(null, bread);
  //console.log('blog', blog)

  var meta_title = guideDetail?.title;
  var meta_desc = `Read about ${guideDetail?.title.toLowerCase()} here and subscribe to our newsletter to stay up-to-date about everything going on at ${site_name}.`

  var ldJson = `{
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "${process.env.GATSBY_SITE_URL}/${PageLinks.guides_resources}/${guideDetail?.slug}"
    },
    "headline": "${guideDetail?.title}",
    "image": "${guideDetail?.image ? guideDetail?.image.url : ""}",
    "publisher": {
      "@type": "Organization",
      "name": "${site_name}",
      "logo": {
        "@type": "ImageObject",
        "url": "${process.env.GATSBY_SITE_URL}/images/mail-logo.png"
      }
    },
    "description": "${meta_desc}"
  }`

  
  return (
    // loading ? 
    //   <PreLoader />
    // :
    <div className="search-header property-header guides-page news-detail-page">
      {guideDetail?.title &&
      <Layout seo_meta={{
        title: meta_title,
        description: meta_desc,
        image: guideDetail?.image
      }}
        menu_slug={"news-details"}
      >

        <Helmet>
            <script  type="application/ld+json">{ldJson}</script>
        </Helmet>

        <GuideDetail {...guideDetail} breadcrumbs={breadcrumbsList} />

        <MoreGuides id={guideDetail?.id}/>

        <Journey />

      </Layout>
      }
    </div>
  )

}

export default GuidesDetailTemplate


export const query = graphql`
query guideDetailQuery($id: ID!) {
    glstrapi { 
      guidesAndResource(id: $id, publicationState: LIVE) {
          id
          title
          slug
          guides_categories {
              id
              category_name
          }
          content
          image {
            url
            alternativeText
          }
          imagetransforms
          ggfx_results {
            id
            transforms
            src_cftle
            src_url
          }
      } 
    }
}`